import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import { SortOrder } from 'types/interfaces/sort';
import {
  CollectionListFetchResponse,
} from '../collectionList/types';
import { CollectionList } from 'types/interfaces/collectionList';

export interface PublicHaveListFetchResponse extends CollectionListFetchResponse {
  haveList: CollectionList[];
}

export interface PublicWantListFetchResponse extends CollectionListFetchResponse {
  wantList: CollectionList[];
}

export interface PublicCollectionFetchRequest {
  username: string;
  page?: number;
  limit?: number;
  sort?: string;
  direction?: SortOrder;
  search?: string;
}

export const publicCollectionApi = createApi({
  reducerPath: 'publicCollectionApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    fetchPublicHaveList: builder.query<
      PublicHaveListFetchResponse,
      PublicCollectionFetchRequest
    >({
      query: ({ username, page = 1, limit = 100, sort, direction, search }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
        });

        if (sort) {
          params.append('sort', sort);
        }

        if (direction) {
          params.append('direction', direction);
        }

        if (search) {
          params.append('search', search);
        }

        return {
          url: `/public/collection/${username}/have-list?${params.toString()}`,
          method: 'GET',
          requiresAuth: false, // Public endpoint - no authentication required
        };
      },
    }),
    fetchPublicWantList: builder.query<
      PublicWantListFetchResponse,
      PublicCollectionFetchRequest
    >({
      query: ({ username, page = 1, limit = 100, sort, direction, search }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
        });

        if (sort) {
          params.append('sort', sort);
        }

        if (direction) {
          params.append('direction', direction);
        }

        if (search) {
          params.append('search', search);
        }

        return {
          url: `/public/collection/${username}/want-list?${params.toString()}`,
          method: 'GET',
          requiresAuth: false, // Public endpoint - no authentication required
        };
      },
    }),
  }),
});

export const {
  useFetchPublicHaveListQuery,
  useFetchPublicWantListQuery,
} = publicCollectionApi;
